// React y Hooks
import React, { useEffect, useRef, useState } from 'react'
// Third-party libraries
import { useHistory } from 'react-router-dom'
import { connect } from "react-redux"
import { bindActionCreators } from 'redux'
import { useTranslation } from 'react-i18next'
import Modal from 'antd/es/modal';
// Material UI components
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import { Backdrop, CircularProgress, Button } from '@material-ui/core'
import AppBar from "@material-ui/core/AppBar"
import Tab from "@material-ui/core/Tab"
import TabContext from "@material-ui/lab/TabContext"
import TabList from "@material-ui/lab/TabList"
import TabPanel from "@material-ui/lab/TabPanel"
import { makeStyles } from '@material-ui/core/styles'
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
// Internal/common components
import TopBarNav from '../../common/TopBarNav'
import BreadcrumbsHistory from '../../common/BreadcrumbsHistory'
// Redux actions
import * as navigationActions from '../../../actions/common/NavigationActions'
import * as OrderActions from "../../../actions/othertransactions/OrderActions"
// Local files
import { OtherTransactionsStyles } from '../OtherTransactionsStyles'
//Components Details
import OrderDetailInfoGeneral from './OrderDetailInfoGeneral'
import OrderDetailReceipt from './OrderDetailReceipt'
import OrderInvoiceChange from './OrderInvoiceChange'
import OrderDetailComments from './OrderDetailComments'

const { confirm } = Modal

const useStyles = makeStyles({
    appbar: {
        backgroundColor: "White",
    },
    tab: {
        backgroundColor: '#A5A5A5',
        '&.Mui-selected': {
            backgroundColor: '#789AC1'
        },
        textTransform: "initial"
    },
    indicator: {
        backgroundColor: "#7a9bc2"
    }
})

const OrderDetail = ({ classes, ...props }) => {
    // Routing
    const history = useHistory()
    //Get params from url
    const { match: { params } } = props;
    //Language
    const { t } = useTranslation();
    //Local style
    const localclass = useStyles();
    // UI states
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [value, setValue] = useState("1");
    // Data state
    const [data, setData] = useState({});
    const [filteredItems, setFilteredItems] = useState([]);
    const [filteredComments, setFilteredComments] = useState([]);
    const [onLoad, setOnLoad] = useState(true);
    // set file PDF
    const [filePDF, setFilePDF] = useState(null);

    // set file XML
    const [fileXML, setFileXML] = useState(null);
    const [keyXML, setKeyXML] = useState(Date.now);
    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }

    //Update route names when change the lenguage
    useEffect(() => {
        props.navigationActions.clean_routes()
        
        const newRoute = {
            path: '/othertransactions',
            linkLegend: t('OtherTransactions'),
            urlParams: [{ key: 'branchOfficeId', value: params.branchOfficeId }]
        }
        props.navigationActions.add_route(newRoute)

        const newRouteOrders = {
            path: '/othertransactions/listOrders',
            linkLegend: t(`OrderDashboard.Orders`),
            urlParams: [{ key: 'branchOfficeId', value: params.branchOfficeId }]
        }
        props.navigationActions.add_route(newRouteOrders)

        const newRouteOrdersDetail = {
            path: '/othertransactions/listOrders/orderDetail',
            linkLegend: t(`OrderDetailDashboard.Detail`),
            urlParams: [{ key: 'pymtOrdId', value: params.pymtOrdId }]
        }
        props.navigationActions.add_route(newRouteOrdersDetail)
    }, [t])
    
    //Load order detail
    useEffect(() => {
        handleOpenBackdrop()
        props.actions.fetch_other_transactions_order_detail(
            props.userLanguage,
            props.userToken, 
            params.pymtOrdId, 
            onError, 
            onSuccessOrderDetail
        )
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const onSuccessOrderDetail = (response) => {
        handleCloseBackdrop();
        setData(response);
        setFilteredItems(response.services);
        setFilteredComments(response.orderComments);
    }
    useEffect(()=>{
        if(data.stateDescription === 'Documentación rechazada' && onLoad === true){
            setValue('4');
            setOnLoad(false);
        }
    }, [data, onLoad]);
    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    return;
                case 403:
                    history.push('/forbidden')
                    return;
                default:
                    break
            }
        }
        Modal.error({
            title: 'Error',
            content: t('commonMessages.alert500')
        })
    }

    //Handle tabs on change
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const checkFileTypePDF = event => {
        let file = event.target.files[0]
        
        if (file != null) {
            let types = ['application/pdf']
            if (types.every(type => file.type !== type)) {
                Modal.error({
                    title: 'Error',
                    content: t('commonMessages.noSupportedFormatInvoice')
                })
                event.target.value = null
                setFilePDF(null);
                return false
            }else if(file.name.length > 150){
                Modal.error({
                    title: 'Error',
                    content: t('commonMessages.maxLengthName')
                })
                event.target.value = null
                setFilePDF(null);
                return false
            } else {                
                let size = (event.target.files[0].size / 1024)/ 1024;
                if (size>25){
                    Modal.error({
                        title: 'Error',
                        content: t('commonMessages.MaxSizeFileAllow')
                    })
                    event.target.value = null
                    setFilePDF(null);
                    return false
                }else{
                    handleInpuFileChangePDF(event)
                }
            }
            
        }
    }
    const checkFileTypeXML = event => {
        let file = event.target.files[0]
        if (file != null) {
            let types = ['text/xml']
            
            if (types.every(type => file.type !== type)) {
                Modal.error({
                    title: 'Error',
                    content: t('commonMessages.noSupportedFormatInvoice')
                })
                event.target.value = null
                setFileXML(null);
                return false
            }else if(file.name.length > 150){
                Modal.error({
                    title: 'Error',
                    content: t('commonMessages.maxLengthName')
                })
                event.target.value = null
                setFileXML(null);
                return false
            } else {
                let size =  (event.target.files[0].size / 1024)/ 1024;
                if (size>25){
                    Modal.error({
                        title: 'Error',
                        content: t('commonMessages.MaxSizeFileAllow')
                    })
                    event.target.value = null
                    setFileXML(null);
                    return false
                }else{
                    handleInpuFileChangeXML(event)
                }
            }
            
        }
    }
    const handleInpuFileChangePDF= (e) => {
        setFilePDF(e.target.files[0])
    };
    const handleInpuFileChangeXML= (e) => {
        setFileXML(e.target.files[0])
    };
    const cleanFiles= (e) => {
        setFileXML(null)
        setFilePDF(null)
        setKeyXML(Date.now)
        
    };
    const setCompletInvoice = (status) => {
        setData({...data, completeInvoice: status}); 
    }  

    const setCompletReceipt = (status) => {
        setData({...data, completeReceipt: status}); 
    }  

    const handleConfirmSendToCheck = () => {
        confirm({
            title: t('OrderDetailDashboard.WantToContinue'),
            content: t('OrderDetailDashboard.SubmittedForVerification'),
            cancelText: t('OrderDetailDashboard.cancel'),
            onOk() {
                handleSendToCheck()
            },
            onCancel() {
              return;
            },
          });
    }

    const handleSendToCheck = () => {
        handleOpenBackdrop()
        props.actions.update_status_order_review_payment(
            props.userLanguage,
            props.userToken, 
            params.pymtOrdId, 
            onError, 
            onSuccessUpdateStatus
        )
    }

    const onSuccessUpdateStatus = (response) => {
        handleCloseBackdrop();
        setData({...data, stateDescription: response.stateDescription}); 
        setValue("1");
        Modal.success({
            content: t('OrderDetailDashboard.SendToValidation'),
        })
    }

    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory />
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={12} >
                        <p className={classes.titles}>{t('OrderDetailDashboard.Title')}</p>
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12} >
                        <TabContext value={value}>
                            <Grid container item xs={12} >
                                <Grid item xs={12} sm={8} md={9} >
                                    <AppBar position="static" elevation={0}>
                                        <TabList onChange={handleChange} className={localclass.appbar} TabIndicatorProps={{ className: localclass.indicator }}>
                                            <Tab label={t('OrderDetailDashboard.TabGeneralInfo')} value="1" className={localclass.tab} />
                                            <Tab label={t('OrderDetailDashboard.TabInvoice')} value="2" className={localclass.tab} />
                                            <Tab label={t('OrderDetailDashboard.TabReceipt')} value="3" className={localclass.tab} />
                                            <Tab label={t('OrderDetailDashboard.TabComments')} value="4" className={localclass.tab} />
                                        </TabList>
                                    </AppBar>
                                </Grid>
                                <Grid item xs={12} sm={4} md={3} style={{textAlign: "right", alignContent: 'center'}}>
                                    <Button 
                                        type="button" 
                                        className={classes.generalBorderWithOutUpperCase} 
                                        variant="outlined" 
                                        startIcon={<OpenInNewIcon />}
                                        onClick={handleConfirmSendToCheck}
                                        disabled={!(data.completeInvoice && data.completeReceipt && (data.stateDescription == 'Asignada' || data.stateDescription == 'Documentación rechazada'))}
                                    > 
                                        {t('OrderDetailDashboard.SendToCheck')} 
                                    </Button>
                                </Grid>
                            </Grid>
                            <TabPanel value="1" className={classes.paddingTabPanel}>
                                <OrderDetailInfoGeneral
                                    t= {t}
                                    classes = {classes}
                                    data = {data}
                                    filteredItems= {filteredItems}
                                    setFilteredItems = {setFilteredItems}
                                />
                            </TabPanel>
                            <TabPanel value="2" className={classes.paddingTabPanel}>
                            <OrderInvoiceChange
                                    t= {t}
                                    classes = {classes}
                                    data = {data}
                                    checkFileTypePDF={checkFileTypePDF}
                                    checkFileTypeXML ={checkFileTypeXML}
                                    filePDF={filePDF}
                                    fileXML={fileXML}
                                    cleanFiles={cleanFiles}
                                    orderId={params.pymtOrdId}
                                    keyXML={keyXML}
                                    setCompletInvoice = {setCompletInvoice}
                                    {...props}
                                />
                           
                            </TabPanel>
                            <TabPanel value="3" className={classes.paddingTabPanel}>
                                <OrderDetailReceipt 
                                    {...props}
                                    t= {t}
                                    classes = {classes} 
                                    setCompletReceipt = {setCompletReceipt}
                                />
                            </TabPanel>
                            <TabPanel value="4" className={classes.paddingTabPanel}>
                                <OrderDetailComments
                                    t= {t}
                                    classes = {classes}
                                    data = {data}
                                    filteredItems= {filteredComments}
                                    setFilteredItems = {setFilteredComments}
                                />
                            </TabPanel>
                        </TabContext>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    userProfile: state.UserProfileReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(OrderActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(OtherTransactionsStyles)(OrderDetail))
